/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";
import ClientStats from "shared/util/ClientStats";
import isApp from "shared/util/isApp";

import {
	LOADED_SPLASH,
	CLICK_SIGNUP,
	CLICK_LOGIN,
	CONFIRM_RECAPTCHA_SUCCESS,
} from "ducks/splash";


// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function splash(state, action) {
	switch (action.type) {
		case LOADED_SPLASH: {
			Analytics.logUIEvent(Analytics.eventNames.onboardingLandedOnLanding);

			if (process.env.PLATFORM === "mobile") {
				if (isApp()) {
					ClientStats.update("app onboarding funnel - loaded page");
				} else {
					ClientStats.update("mobile web onboarding funnel - loaded page");
				}
			} else {
				ClientStats.update("desktop onboarding funnel - loaded page");
			}

			return;
		}

		case CLICK_SIGNUP: {
			Analytics.logUIEvent(Analytics.eventNames.onboardingSelectedSignUpOnLanding);

			if (process.env.PLATFORM === "mobile") {
				if (isApp()) {
					ClientStats.update("app onboarding funnel - clicked signup");
				} else {
					ClientStats.update("mobile web onboarding funnel - clicked signup");
				}
			} else {
				ClientStats.update("desktop onboarding funnel - clicked signup");
			}

			return;
		}

		case CLICK_LOGIN: {
			Analytics.logUIEvent(Analytics.eventNames.onboardingSelectedSignInOnLanding);

			if (process.env.PLATFORM === "mobile") {
				if (isApp()) {
					ClientStats.update("app onboarding funnel - clicked login");
				} else {
					ClientStats.update("mobile web onboarding funnel - clicked login");
				}
			} else {
				ClientStats.update("desktop onboarding funnel - clicked login");
			}

			return;
		}

		case CONFIRM_RECAPTCHA_SUCCESS: {
			const { payload: { score, isCaptchaShowing, page } } = action;
			Analytics.logUIEvent(
				Analytics.eventNames.recaptchaScore,
				{
					data: {
						score,
						isCaptchaShowing,
						page,
					},
				},
			);
			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/splash.js